import { clsx } from 'clsx';
import { ForwardedRef, forwardRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import JxtInput from '../JxtInput';
import { IJxtPassword } from './types';

const JxtPassword = ({ disabled, ...props }: IJxtPassword, ref: ForwardedRef<HTMLElement>) => {
  const { t } = useTranslation();
  const [passwordVisible, setPasswordVisible] = useState<boolean>(false);

  const togglePasswordVisibility = () => setPasswordVisible((visible) => !visible);

  return (
    <JxtInput
      {...props}
      ref={ref}
      disabled={disabled}
      type={passwordVisible ? 'text' : 'password'}
      rightAddon={
        <button
          type="button"
          className={clsx(
            disabled ? 'text-neutral-60 cursor-not-allowed' : 'text-neutral-120 cursor-pointer',
            'flex items-center rounded-sm focus:outline-hidden focus-visible:ring-2 focus-visible:ring-primary-30'
          )}
          onClick={togglePasswordVisibility}
          disabled={disabled}
          aria-label={
            passwordVisible
              ? t<string>('hide-password', { defaultValue: 'Hide password' })
              : t<string>('show-password', { defaultValue: 'Show password' })
          }
        >
          <i className={clsx('fas fa-fw', passwordVisible ? 'fa-eye-slash' : 'fa-eye')} aria-hidden="true" />
        </button>
      }
    />
  );
};

export default forwardRef(JxtPassword);
